import { z } from 'zod'

type RefineEnum = 'string' | 'number' | 'bigint' | 'date' | 'array' | 'set'

export type TResetForm = {
  isPartial: boolean
  exceptionEventTypeId: string
  comment: string
  proposedStartTime?: Date | undefined
  hoursToMove?: number | undefined
}

export function useResetPullAheadForm() {
  function getResolvedResetPullAheadSchema(isPullAhead: boolean) {
    const schema = z.object({
      isPartial: z.boolean(),
      exceptionEventTypeId: z
        .string()
        .min(1, { message: 'Please, select an Exception Event Type' }),
      proposedStartTime: isPullAhead
        ? z.date({ message: 'Please, select a date' })
        : z.date().optional(),
      hoursToMove: z.coerce
        .number({ message: 'Please, enter a valid number' })
        .optional(),
      comment: z.string(),
    })

    return schema
  }

  const handleSuperRefine = (message: string) => {
    const superRefineObject = {
      code: z.ZodIssueCode.too_small,
      minimum: 0,
      inclusive: true,
      type: 'number' as RefineEnum,
      path: ['hoursToMove'],
      message,
    }

    return superRefineObject
  }

  return { getResolvedResetPullAheadSchema, handleSuperRefine }
}
